export default __webpack_public_path__ + "static/media/modal-close-btn.3dd2f178.svg";